// extracted by mini-css-extract-plugin
export default {"head":"wish_head__KnKMH","list":"wish_list__VoieY","button":"wish_button__b2uI2"};